export default __webpack_public_path__ + "static/media/header.3e985348.svg";